import { API_BASE_URL } from "../constants/app_constants";
import axios from "axios";
import { USER_ID_KEY, USER_TOKEN_KEY } from "../constants/app_constants";
import LocalStorageService2 from "../../features/data/service/impl/local_storage_service_impl";
import { store } from "../../features/presentation/state/store";

export const instance = axios.create({ baseURL: API_BASE_URL, headers: { "Content-Type": "application/json" } });

instance.interceptors.request.use( async config=> {
    try {
        let localStorage = new LocalStorageService2();
        let token = await localStorage.getData(USER_TOKEN_KEY);
        if(token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config;
    } catch (e) {
        
    }
    return config;
})

instance.interceptors.response.use(response=> response, (error)=> {
    if (
        error.response &&
        error.response.status === 500 &&
        error.response.data?.success === false &&
        error.response.data?.message === "Failed to authenticate token."
    ) {
        let localStorage = new LocalStorageService2();
        localStorage.deleteData(USER_ID_KEY);
        localStorage.deleteData(USER_TOKEN_KEY);
        window.location.href = '/login'
    }
    return Promise.reject(error);
});

export default instance;